<div class="tile-for-order-type">
    <shared-thumb-for-order-type class="tile-for-order-type__img" [loading]="(image$ | async)?.isDownloading"
        [src]="(image$ | async)?.data?.ImageUrl">
    </shared-thumb-for-order-type>

    <shared-header [loading]="!orderType" [center]="true" class="tile-for-order-type__h" type="4" marginTop="xs"
        marginBottom="xs">
        {{orderType?.Description}}
    </shared-header>

    <shared-text [brandAccent]="false" [dimmed]="true" class="tile-for-order-type__desc"
        *ngIf="orderType?.Instructions">
        {{orderType?.Instructions}}
    </shared-text>
</div>